__turbopack_context__.v({
  "shadowedBox": "mqq3gW_shadowedBox",
  "subtitle": "mqq3gW_subtitle",
  "titleDiv": "mqq3gW_titleDiv",
});
